<template>
    <div class="content flex wrap center" :class="[{ 'fit': !base.Util().validate(entities.length) }]">
        <div class="head">
            <div class="title">
                <h1>تاریخچه تماس</h1>
            </div>
        </div>
        <div class="sync flex wrap start vcenter">
            <img :class="[{ 'syncing': syncing }]" v-lazy="'/images/sync.webp'" :alt="'sync'" loading="lazy"
                @click.prevent="init()">
            <p v-if="time > 0">تاریخ آخرین بروزرسانی: {{ base.Util().time({ unix: time, time: true }).split(' ')[0] }}
            </p>
        </div>
        <template v-for="(entity, index) in entities" :key="index">
            <row class="flex wrap center vcenter">
                <div class="status" :class="[
                    { 'green': entity.status === 'ANSWERED' },
                    { 'orange': entity.status === 'BUSY' },
                    { 'crimson': entity.status === 'NO ANSWER' || entity.status === 'FAILED' }]">
                </div>
                <div class="profile flex wrap center vcenter">
                    <img v-lazy="'/images/profile.webp'" :alt="'نمایه'" loading="lazy">
                </div>
                <div class="data flex wrap start vcenter">
                    <p
                        @click.prevent="oncopy(`I${index}`, entity.identity ? entity.identity?.display_name : 'بدون نام')">
                        <span>نام
                            مخاطب:</span> {{ copied[`I${index}`] || (entity.identity
                                ? entity.identity?.display_name
                                : 'بدون نام') }}
                    </p>
                    <p class="mobile" @click.prevent="oncopy(`C${index}`, entity.cid)">
                        <span>شماره همراه:</span> {{ copied[`C${index}`] || entity.cid }}
                    </p>
                </div>
                <div class="actions flex wrap center vcenter">
                    <img v-lazy="`/images/${entity.direction === 'incoming' ? 'call-in' : 'call-out'}.webp`"
                        :alt="'telephone'" loading="lazy" @click.prevent="$emit('dial', entity.cid)">
                    <img v-if="entity.voice"
                        v-lazy="`/images/${data?.theme === 'dark' ? 'record_light' : 'record'}.webp`" :alt="'record'"
                        loading="lazy" @click.prevent="download(entity.voice)">
                </div>
            </row>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'History',
    props: ['data'],
    inject: ['base'],
    computed: {
        username() {
            return this.data?.username
        }
    },
    created() {
        if (this.base.Util().validate(this.username))
            this.init()
    },
    data() {
        return {
            entities: [],
            syncing: false,
            time: 0,
            copied: {}
        }
    },
    watch: {
        username(newUsername, oldUsername) {
            this.init()
        }
    },
    methods: {
        init() {
            this.syncing = true
            this.base.API().post(`Stream/CDR/GetHistory`, {
                data: {
                    uid: '{My:0}',
                    cid: this.data?.username
                }
            }, (response) => {
                this.syncing = false
                this.time = Date.now()
                if (this.base.Util().success(response)
                    && response.data.data) {
                    this.entities = response.data.data
                }
            }, (error) => {
                this.syncing = false
                this.time = Date.now()
            })
        },
        download(source) {
            this.base.API().download(source, (response) => {
                this.base.Entities().download({
                    type: 'audio/wav',
                    name: source,
                    raw: response.data
                })
            }, (error) => {
            })
        },
        oncopy(key, value) {
            navigator.clipboard.writeText(value)
            this.copied[key] = 'کپی شد!'
            setTimeout(() => {
                this.copied[key] = ''
            }, 500)
        }
    }
}
</script>

<style scoped src="../../assets/css/components/phone/history.css"></style>
<style scoped src="../../assets/css/components/phone/history_dark.css"></style>